'use strict';
const _ = require('underscore');
const Ajax = require('common/infra/ajax');

class API {
    getIdeasByQuery(query, limit, cursor) {
        const path = `/api/feedback/admin/ideas`;
        let params = new URLSearchParams();

        params.append('limit', limit);

        if(cursor) {
            params.append('nextCursor', cursor);
        }

        if(query.states) {
            _.each(query.states, s => {
                params.append('state', s);
            });
        }

        return Ajax.GET(`${path}?${params.toString()}`);
    }

    update(ideaID, json) {
        return Ajax.PUT(`/api/feedback/admin/ideas/${ideaID}`, json);
    }

    getIdeaStats() {
        return Ajax.GET('/api/feedback/admin/ideas/stats');
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./feedback/infra/api/admin/idea.js